const getLoadingElement = () => document.getElementById('spinner-loading');
let requestCounter = 0;
let skip = false;

export const showLoading = () => { // eslint-disable-line
  requestCounter += 1;
  if (getLoadingElement() && getLoadingElement().className !== 'HOME__loading' && !skip) {
    getLoadingElement().className = 'HOME__loading';
  } else {
    skip = false;
  }
};
export const hideLoading = () => { // eslint-disable-line
  requestCounter -= 1;
  if (requestCounter === 0 && getLoadingElement()) {
    getLoadingElement().className = 'HOME__stop_loading';
  }
};

export const skipLoading = () => { // eslint-disable-line
  skip = true;
};



// WEBPACK FOOTER //
// ./src/common/functions/loading.js